import { render, staticRenderFns } from "./ModalAlterarPontuacaoProfissional.vue?vue&type=template&id=65a0deba&scoped=true"
import script from "./ModalAlterarPontuacaoProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarPontuacaoProfissional.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarPontuacaoProfissional.vue?vue&type=style&index=0&id=65a0deba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0deba",
  null
  
)

export default component.exports